import {
  OverlayWrapper,
  Container,
  Close,
  Image
} from './styles'
import { Icon } from '../../../assets/icons'

type Props = {
  isShowing: boolean;
  handleClose: () => void;
  imageURL: string;
  type?: 'small' | 'medium' | 'large'
}

const ZoomModal = ({ isShowing, imageURL, handleClose, type = 'medium' }: Props) => {
  return (
    <OverlayWrapper isShowing={isShowing}>
      <Container type={type}>
        <Close onClick={handleClose}>
          <Icon name="close" />
        </Close>

        <Image src={imageURL} />
      </Container>
    </OverlayWrapper>
  )
}

export default ZoomModal
